import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TransactionCategory } from '@shipstation/financial-services-ui-components';

import { emptyObject } from 'ui-components/default-props/empty';
import { TaxFormContextProvider } from '../../pages/settings/payment-and-subscription/context/tax-form-context-provider';
import { FinancialServicesUIProviderWrapper } from '../financial-services-ui-provider-wrapper';
import FsuiContextProvider, { SOURCE_SUBSCRIPTION_BILLING, SOURCE_WALLET_UPDATE_PAYMENT } from '../fsui-context-provider';
import { PageEventSourceStrings } from '../../pages/settings/payment-and-subscription/hooks/use-track-event';
import Global from '../../store/global-selectors';
import { usePaymentAndSubscriptionMegaContext } from '../../pages/settings/payment-and-subscription/context';
import { getBillingInfoFromPaymentMethod } from '../mapping';
import { useHumanScript } from '../../hooks/use-human-script';

import { PaymentUpdateModal, PaymentUpdateContextProvider } from './';

export const PaymentUpdateModalWrapper = ({ transactionCategory = TransactionCategory.Subscription, trackConfirmClick, onClose }) => {
  useHumanScript();
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);
  const sellerSubscriptionCurrencyCode = useSelector(Global.selectSellerSubscriptionCurrency);
  const seller = useSelector((state) => state.seller) || emptyObject;
  const isSubscriptionCategory = transactionCategory === TransactionCategory.Subscription;
  const currencyCode = isSubscriptionCategory ? sellerSubscriptionCurrencyCode : sellerCurrencyCode;
  const addtlReturnParams = isSubscriptionCategory
    ? `${SOURCE_SUBSCRIPTION_BILLING}&transactionCategory=${transactionCategory}`
    : SOURCE_WALLET_UPDATE_PAYMENT;
  const trackSource = isSubscriptionCategory
    ? PageEventSourceStrings.ADD_PAYMENT_METHOD_SUBSCRIPTION
    : PageEventSourceStrings.WALLET_UPDATE;

  const { paymentMethodDetails: paymentMethods } = usePaymentAndSubscriptionMegaContext();

  const initialBillingInfo = useMemo(() => {
    const initialPaymentMethod = paymentMethods?.find((method) => method.assignedPreferences?.includes(transactionCategory)) || null;
    return getBillingInfoFromPaymentMethod(initialPaymentMethod, seller);
  }, [paymentMethods, seller, transactionCategory]);

  return (
    <FsuiContextProvider addtlReturnParams={addtlReturnParams} currencyCode={currencyCode} transactionCategory={transactionCategory}>
      <FinancialServicesUIProviderWrapper initialBillingInfo={initialBillingInfo}>
        <TaxFormContextProvider isEditing={false} source={trackSource}>
          <PaymentUpdateContextProvider onClose={onClose} trackConfirmClick={trackConfirmClick} transactionCategory={transactionCategory}>
            <PaymentUpdateModal onClose={onClose} transactionCategory={transactionCategory} />
          </PaymentUpdateContextProvider>
        </TaxFormContextProvider>
      </FinancialServicesUIProviderWrapper>
    </FsuiContextProvider>
  );
};
